import {createStore} from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import AuthorizationSystem from './Authorization/main.js';
import Dropdowns from './Dropdowns/main.js';
import UserSystem from './User/main.js';
import ContentSystem from './Content/main.js';
import CalendarSystem from './Calendar/main.js';
import SearchSystem from './Search/main.js';
import FormsInterfaceSystem from './FormsInterface/main.js';
import MarketPulse from './MarketPulse/main.js';
import OldSignals from './Signals/main.js';
import TwitterHype from './TwitterHype/main.js';
import HeaderSystem from './Header/main.js';

import Audioplayer from '@/Groups/Audioplayer/store/audioplayerStore.js';
import Slider from '@/Groups/Slider/store/sliderStore.js';
import PulseMarket from '@/Groups/MarketPulse/store/marketPulseStore.js';
import Notifications from '@/Groups/Notifications/store/notificationsStore.js';
import ColorThemesManager from '@/Groups/ColorThemesManager/store/colorThemeStore.js';
import Briefcase from '@/Groups/Briefcase/store/briefcaseStore';
import Pon from '@/Groups/Pon/store/ponStore';
import Scanner from '@/Groups/Scanner/store/scannerStore.js';
import Storeroom from '@/Groups/Storeroom/store/storeroomStore.js';
import Forecasters from '@/Groups/Forecasters/store/forecastersStore.js';
import KnowledgeBase from '@/Groups/KnowledgeBase/store/knowledgeBaseStore.js';
import CoinTooltip from '@/Groups/CoinTooltip/store/tooltipStore.js';
import OverlayManager from '@/Groups/OverlayManager/store/overlayManagerStore.js';
import Signals from '@/Groups/Signals/store/signalsStore.js';
import Polymarket from '@/Groups/Polymarket/store/polymarketStore.js';

export default createStore({
  state: {
    accessToken: null,
    // isAuthenticated: !!localStorage.getItem('access_token'),
    error: null, // Хранение ошибки
    success: null, // Хранение успеха
  },
  getters: {
    getBackendUrl: () => process.env.VUE_APP_BACKEND_URL,
    getFrontendUrl: () => process.env.VUE_APP_FRONTEND_URL,
    getCookieExpiresDays: () => process.env.VUE_APP_COOKIE_EXPIRES_DAYS,
    getAccessToken: (state) => state.accessToken,
    getErrorMessage: (state) => state.error,
    getSuccessMessage: (state) => state.success,
  },
  mutations: {
    setAccessToken(state, token) {
      state.accessToken = token;
    },
    clearAccessToken(state) {
      state.accessToken = null;
    },
    // setAuthentication(state, status) {
    //   state.isAuthenticated = status;
    // },
    setErrorMessage(state, error) {
      state.error = error;
    },
    clearErrorMessage(state) {
      state.error = null;
    },
    setSuccessMessage(state, success) {
      state.success = success;
    },
    clearSuccessMessage(state) {
      state.success = null;
    },
  },
  actions: {
    saveAccessToken({commit}, token) {
      commit('setAccessToken', token);
      // localStorage.setItem('access_token', token);
    },
    async logout({commit, getters}) {
      // Вызываем API для blacklist refresh token (кука отправится автоматически)
      try {
        await fetch(`${getters.getBackendUrl}/api/token/blacklist/`, {
          method: 'POST',
          credentials: 'include',
          headers: {'Content-Type': 'application/json'},
        });
      } catch (error) {
        console.error('Error during logout:', error);
      }
      // Очищаем access token из store
      commit('clearAccessToken');
    },
    setErrorMessage({commit}, error) {
      commit('setErrorMessage', error);
    },
    clearErrorMessage({commit}) {
      commit('clearErrorMessage');
    },
    setSuccessMessage({commit}, success) {
      commit('setSuccessMessage', success);
    },
    clearSuccessMessage({commit}) {
      commit('clearSuccessMessage');
    },
  },

  modules: {
    //Система управления элементами, относящиеся к управлению сессией (а также виджетом управления сессией)
    AuthorizationSystem: AuthorizationSystem,
    //Система управления открытыми дропдаунами
    Dropdowns: Dropdowns,
    //Система контроля данных пользователя
    UserSystem: UserSystem,
    //Система управления контентом
    ContentSystem: ContentSystem,
    //Система управления страницей форкастеры
    CalendarSystem: CalendarSystem,
    //Система для управления поиском
    SearchSystem: SearchSystem,
    //Система управления элементами формы
    FormsInterfaceSystem: FormsInterfaceSystem,
    //Система управления MarketPulse
    MarketPulse: MarketPulse,
    //Система управления сигналами
    OldSignals: OldSignals,
    //Стор для Твиттер Хайпа
    TwitterHype: TwitterHype,
    //Стор для шапки
    HeaderSystem: HeaderSystem,


    //------------------------
    // НОВАЯ АРХИТЕКТУРА
    //------------------------
    //Стор для слайдера
    Slider: Slider,
    //Стор для аудиоплеера
    Audioplayer: Audioplayer,
    //Система управления уведомлениями
    Notifications: Notifications,
    //Система управления маркет пульс
    PulseMarket: PulseMarket,
    //Система управлением цветовой темой сайта
    ColorThemesManager: ColorThemesManager,
    //Стор для портфеля
    Briefcase: Briefcase,
    //Стор для инфо по пону
    Pon: Pon,
    //Стор для скриннера
    Scanner: Scanner,
    //Стор для кладовой
    Storeroom: Storeroom,
    //Стор для форкастеров
    Forecasters: Forecasters,
    //Стор для базы знаний
    KnowledgeBase: KnowledgeBase,
    //Стор для тултипа монет
    CoinTooltip: CoinTooltip,
    //Стор для всплывающих сообщений
    OverlayManager: OverlayManager,
    //Сигналы 
    Signals: Signals,
    //Полимаркет
    Polymarket: Polymarket,
  },

  plugins: [
    createPersistedState({
      key: 'access_token', // Название ключа в localStorage или sessionStorage
      paths: ['accessToken'], // Указываем конкретные пути, которые нужно сохранять
      storage: window.localStorage, // Или используйте sessionStorage
    }),
  ],
});
